// import React, { useState } from "react";
// import { CallClient } from "@azure/communication-calling";
// // Corrected import: Use AzureCommunicationTokenCredential
// import { AzureCommunicationTokenCredential } from "@azure/communication-common";

// export default function JoinRoom() {
//   const [roomId, setRoomId] = useState("");
//   const [userToken, setUserToken] = useState("");
//   const [status, setStatus] = useState("");

//   const joinRoom = async () => {
//     try {
//       setStatus("Joining...");
//       const callClient = new CallClient();

//       // Corrected instantiation: Use AzureCommunicationTokenCredential
//       const tokenCredential = new AzureCommunicationTokenCredential(userToken);

//       const callAgent = await callClient.createCallAgent(tokenCredential);

//       await callAgent.join({ roomId }, {});
//       setStatus("Joined the room successfully!");
//       console.log("Successfully joined room:", roomId);

//     } catch (err) {
//       console.error("Failed to join room:", err);
//       setStatus("Failed to join: " + err.message);
//     }
//   };

//   return (
//     <div>
//       <h2>Join Azure Communication Room</h2>
//       <p>Enter the Room ID and your Azure Communication Services User Token.</p>
//       <input
//         type="text"
//         placeholder="Room ID (e.g., '12345678-abcd-efgh-ijkl-1234567890ab')"
//         value={roomId}
//         onChange={e => setRoomId(e.target.value)}
//         style={{ width: '300px', padding: '8px', margin: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
//       />
//       <br />
//       <input
//         type="text"
//         placeholder="Azure ACS User Token"
//         value={userToken}
//         onChange={e => setUserToken(e.target.value)}
//         style={{ width: '300px', padding: '8px', margin: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
//       />
//       <br />
//       <button onClick={joinRoom}
//         style={{ padding: '10px 20px', margin: '5px', borderRadius: '4px', border: 'none', backgroundColor: '#0078d4', color: 'white', cursor: 'pointer' }}
//       >
//         Join Room
//       </button>
//       <div style={{ marginTop: '10px', fontWeight: 'bold', color: status.startsWith('Failed') ? 'red' : 'green' }}>
//         Status: {status}
//       </div>
//       <p style={{ fontSize: '0.8em', color: '#666' }}>
//         * Ensure your user token is valid and the room ID exists and is active.
//       </p>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  CallClient,
  CallAgent, // CallAgent is used in state and cleanup, so it's not truly unused.
  LocalVideoStream,
  VideoStreamRenderer,
} from '@azure/communication-calling';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Paper,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  useTheme,
  alpha,
} from '@mui/material';
import {
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Videocam as VideocamIcon,
  VideocamOff as VideocamOffIcon,
  CallEnd as CallEndIcon,
  Add as AddIcon,
  Settings as SettingsIcon,
  Stop as StopIcon,
  FiberManualRecord as FiberManualRecordIcon,
} from '@mui/icons-material';

// --- Main Component ---
export default function JoinRoom() {
  const theme = useTheme(); // Access the theme object for Figma colors

  // ACS Call State
  const [roomId, setRoomId] = useState('');
  const [userToken, setUserToken] = useState('');
  const [status, setStatus] = useState('Enter Room ID and User Token to join.');
  const [callClient, setCallClient] = useState(null);
  const [callAgent, setCallAgent] = useState(null); // Used in cleanup useEffect
  const [call, setCall] = useState(null);
  const [localVideoStream, setLocalVideoStream] = useState(null);
  const [remoteParticipants, setRemoteParticipants] = useState([]);
  const [isMuted, setIsMuted] = useState(false);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [callDuration, setCallDuration] = useState(0); // New state for call duration

  // Add display name state
  const [displayName, setDisplayName] = useState('');

  // Device Management State
  const [videoDevices, setVideoDevices] = useState([]);
  const [audioDevices, setAudioDevices] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState('');
  const [selectedMicrophoneId, setSelectedMicrophoneId] = useState('');

  // Refs for video elements
  const localVideoRef = useRef(null);
  const remoteVideoRefs = useRef(new Map());

  // Recording State
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);

  // --- Initialize CallClient and Device Manager on Mount ---
  useEffect(() => {
    const initCallClient = async () => {
      try {
        const client = new CallClient();
        setCallClient(client);
        const deviceManager = client.getDeviceManager();
        const cameras = await deviceManager.getCameraList();
        const microphones = await deviceManager.getMicrophoneList();
        setVideoDevices(cameras);
        setAudioDevices(microphones);
        if (cameras.length > 0) setSelectedCameraId(cameras[0].id);
        if (microphones.length > 0) setSelectedMicrophoneId(microphones[0].id);
      } catch (e) {
        setError("Failed to initialize CallClient or get devices: " + e.message);
        console.error(e);
      }
    };
    initCallClient();
  }, []); // Empty dependency array means this runs once on mount

  // --- Video Rendering Functions ---

  const renderLocalVideoStream = useCallback(async (stream) => {
    if (localVideoRef.current && stream) {
      try {
        const renderer = new VideoStreamRenderer(stream);
        const view = await renderer.createView();
        localVideoRef.current.innerHTML = ''; // Clear previous view
        localVideoRef.current.appendChild(view.target);
        console.log("Local video stream rendered.");
      } catch (e) {
        setError("Failed to render local video: " + e.message);
        console.error(e);
      }
    }
  }, []); // No dependencies as it only uses refs and fixed functions

  const renderRemoteVideoStream = useCallback(async (participantId, stream) => {
    const videoContainer = remoteVideoRefs.current.get(participantId);
    if (videoContainer && stream) {
      try {
        const renderer = new VideoStreamRenderer(stream);
        const view = await renderer.createView();
        videoContainer.innerHTML = ''; // Clear previous view
        videoContainer.appendChild(view.target);
        console.log(`Remote video stream for ${participantId} rendered.`);
      } catch (e) {
        setError(`Failed to render remote video for ${participantId}: ` + e.message);
        console.error(e);
      }
    }
  }, []); // No dependencies as it only uses refs and fixed functions

  // Handle individual participant updates (video, audio, state)
  const subscribeToParticipant = useCallback((participant) => {
    const videoStreamAdded = (e) => {
      e.streams.forEach(stream => {
        console.log(`Remote video stream added for ${participant.displayName || participant.identifier.rawId}`);
        renderRemoteVideoStream(participant.identifier.rawId, stream);
      });
    };
    const videoStreamRemoved = (e) => {
      e.streams.forEach(stream => {
        console.log(`Remote video stream removed for ${participant.displayName || participant.identifier.rawId}`);
        // Remove the video element if it exists
        const videoContainer = remoteVideoRefs.current.get(participant.identifier.rawId);
        if (videoContainer) {
          videoContainer.innerHTML = ''; // Clear the video element
        }
      });
    };

    participant.on('videoStreamsUpdated', videoStreamAdded);
    participant.on('videoStreamsUpdated', videoStreamRemoved);

    // Render any existing streams
    participant.videoStreams.forEach(stream => {
      renderRemoteVideoStream(participant.identifier.rawId, stream);
    });

    return () => {
      participant.off('videoStreamsUpdated', videoStreamAdded);
      participant.off('videoStreamsUpdated', videoStreamRemoved);
    };
  }, [renderRemoteVideoStream]); // Added renderRemoteVideoStream as a dependency

  // Handle remote participant updates (add/remove)
  const subscribeToRemoteParticipants = useCallback((currentCall) => {
    const participantAdded = (e) => {
      e.participants.forEach(p => {
        console.log(`Remote participant added: ${p.displayName || p.identifier.rawId}`);
        setRemoteParticipants(prev => [...prev, p]);
        subscribeToParticipant(p);
      });
    };

    const participantRemoved = (e) => {
      e.participants.forEach(p => {
        console.log(`Remote participant removed: ${p.displayName || p.identifier.rawId}`);
        setRemoteParticipants(prev => prev.filter(rp => rp.identifier.rawId !== p.identifier.rawId));
      });
    };

    currentCall.on('remoteParticipantsUpdated', participantAdded);
    currentCall.on('remoteParticipantsUpdated', participantRemoved);

    // Initial participants
    currentCall.remoteParticipants.forEach(p => {
      console.log(`Initial remote participant: ${p.displayName || p.identifier.rawId}`);
      setRemoteParticipants(prev => [...prev, p]);
      subscribeToParticipant(p);
    });

    return () => {
      currentCall.off('remoteParticipantsUpdated', participantAdded);
      currentCall.off('remoteParticipantsUpdated', participantRemoved);
    };
  }, [subscribeToParticipant]); // Added subscribeToParticipant as a dependency

  const hangUp = useCallback(async () => {
    if (call) {
      setLoading(true);
      try {
        if (localVideoStream) {
          await call.stopVideo(localVideoStream);
          localVideoStream.dispose();
          setLocalVideoStream(null);
          if (localVideoRef.current) {
            localVideoRef.current.innerHTML = '';
          }
        }
        await call.hangUp();
        setCall(null);
        setCallAgent(null); // Dispose call agent as well
        setRemoteParticipants([]);
        setIsMuted(false);
        setIsCameraOn(false);
        setCallDuration(0); // Reset call duration
        setStatus("Call ended.");
      } catch (err) {
        setError("Failed to hang up: " + err.message);
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  }, [call, localVideoStream]); // Added call and localVideoStream as dependencies

  const toggleMute = useCallback(async () => {
    if (call) {
      setLoading(true);
      try {
        if (isMuted) {
          await call.unmute();
          setIsMuted(false);
          setStatus("Microphone unmuted.");
        } else {
          await call.mute();
          setIsMuted(true);
          setStatus("Microphone muted.");
        }
      } catch (err) {
        setError("Failed to toggle mute: " + err.message);
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  }, [call, isMuted]); // Added call and isMuted as dependencies

  // --- Core Call Actions ---
  // toggleCamera is defined before joinRoom to resolve "used before defined" warning
  const toggleCamera = useCallback(async (turnOn) => {
    if (!call || !callClient) {
      setError("Not in a call or CallClient not initialized.");
      return;
    }
    if (!selectedCameraId) {
      setError("No camera selected.");
      return;
    }

    setLoading(true);
    try {
      if (turnOn === true || (turnOn === undefined && !isCameraOn)) { // Turn camera on
        const localStream = new LocalVideoStream(selectedCameraId);
        await call.startVideo(localStream);
        setLocalVideoStream(localStream);
        setIsCameraOn(true);
        setStatus("Camera turned on.");
        renderLocalVideoStream(localStream); // Render local preview
      } else { // Turn camera off
        if (localVideoStream) {
          await call.stopVideo(localVideoStream);
          localVideoStream.dispose();
          setLocalVideoStream(null);
          if (localVideoRef.current) {
            localVideoRef.current.innerHTML = ''; // Clear video element
          }
        }
        setIsCameraOn(false);
        setStatus("Camera turned off.");
      }
    } catch (err) {
      setError("Failed to toggle camera: " + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [call, callClient, selectedCameraId, isCameraOn, localVideoStream, renderLocalVideoStream]); // Added all necessary dependencies

  const joinRoom = useCallback(async () => {
    if (!callClient) {
      setError("CallClient not initialized.");
      return;
    }
    if (!roomId || !userToken) {
      setError("Room ID and User Token are required.");
      return;
    }

    setLoading(true);
    setError(null);
    setStatus("Joining...");

    try {
      const tokenCredential = new AzureCommunicationTokenCredential(userToken);
      const agent = await callClient.createCallAgent(tokenCredential, { displayName });
      setCallAgent(agent);

      // Add listener for calls created by this agent (e.g., incoming calls)
      agent.on('callsUpdated', (e) => {
        e.added.forEach(addedCall => {
          console.log('Call added:', addedCall);
          setCall(addedCall);
          subscribeToRemoteParticipants(addedCall);
        });
        e.removed.forEach(removedCall => {
          console.log('Call removed:', removedCall);
          setCall(null);
          setLocalVideoStream(null);
          setRemoteParticipants([]);
          setIsMuted(false);
          setIsCameraOn(false);
          setCallDuration(0); // Reset call duration
          setStatus("Call ended.");
          // Ensure hangUp is called if the call is removed externally
          hangUp();
        });
      });

      // Join the room
      const currentCall = await agent.join({ roomId }, {
        // Optional: you can specify video/audio options here if you want to start with them
        // videoOptions: { localVideoStreams: [new LocalVideoStream(selectedCameraId)] },
        // audioOptions: { muted: false },
      });
      setCall(currentCall);
      setStatus("Joined the room successfully!");
      setCallDuration(0); // Start timer

      // Subscribe to call state changes
      currentCall.on('stateChanged', () => {
        console.log('Call state changed:', currentCall.state);
        if (currentCall.state === 'Disconnected' || currentCall.state === 'Disconnecting') {
          hangUp(); // Ensure cleanup on disconnect
        }
      });

      // Subscribe to remote participants
      subscribeToRemoteParticipants(currentCall);

      // Start local video preview if a camera is selected
      if (selectedCameraId && videoDevices.length > 0) {
        await toggleCamera(true); // Turn camera on
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError("Failed to join: " + err.message);
      console.error("Failed to join room:", err);
    }
  }, [callClient, roomId, userToken, selectedCameraId, videoDevices, subscribeToRemoteParticipants, toggleCamera, hangUp, displayName]); // Added hangUp and toggleCamera as dependencies


  // --- Device Selection Handlers ---
  const handleCameraChange = useCallback(async (event) => {
    const newCameraId = event.target.value;
    setSelectedCameraId(newCameraId);
    // If camera was on, switch to new camera
    if (isCameraOn && call && localVideoStream) {
      await toggleCamera(false); // Stop current
      await toggleCamera(true);  // Start new
    }
  }, [isCameraOn, call, localVideoStream, toggleCamera]);

  const handleMicrophoneChange = useCallback(async (event) => {
    const newMicrophoneId = event.target.value;
    setSelectedMicrophoneId(newMicrophoneId);
    if (callClient) {
      try {
        const deviceManager = callClient.getDeviceManager();
        // Find the device object from the array using the ID
        const selectedDevice = audioDevices.find(d => d.id === newMicrophoneId);
        if (selectedDevice) {
          await deviceManager.selectMicrophone(selectedDevice);
          setStatus("Microphone changed.");
        } else {
          setError("Selected microphone not found.");
        }
      } catch (e) {
        setError("Failed to change microphone: " + e.message);
        console.error(e);
      }
    }
  }, [callClient, audioDevices]);

  // --- Call Duration Timer ---
  useEffect(() => {
    let timer;
    if (call) {
      timer = setInterval(() => {
        setCallDuration(prevDuration => prevDuration + 1);
      }, 1000);
    } else {
      clearInterval(timer);
      setCallDuration(0); // Reset when call ends
    }
    return () => clearInterval(timer);
  }, [call]);

  // Format call duration for display (HH:MM:SS)
  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
  };

  // --- Recording Functions ---
  const startRecording = async () => {
    try {
      // Prompt user to share screen with audio (system audio)
      const displayStream = await navigator.mediaDevices.getDisplayMedia({ video: false, audio: true });
      if (!displayStream) {
        setError('Could not get system audio stream.');
        return;
      }
      const recorder = new MediaRecorder(displayStream);
      setMediaRecorder(recorder);
      setRecordedChunks([]);
      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) setRecordedChunks(prev => [...prev, e.data]);
      };
      recorder.start();
      setIsRecording(true);

      // Stop recording if the user stops sharing
      displayStream.getVideoTracks().forEach(track => {
        track.onended = () => {
          if (isRecording) stopRecording();
        };
      });
    } catch (err) {
      setError('Failed to start system audio recording: ' + (err.message || err));
      console.error('MediaRecorder error:', err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  // --- Cleanup on component unmount or call end ---
  useEffect(() => {
    return () => {
      if (call) {
        console.log("Component unmounting, hanging up call...");
        call.hangUp().catch(e => console.error("Error hanging up on unmount:", e));
      }
      if (callAgent) { // callAgent is used here, so the ESLint warning is often a false positive.
        console.log("Disposing call agent...");
        callAgent.dispose();
      }
      if (localVideoStream) {
        localVideoStream.dispose();
      }
      if (mediaRecorder) {
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach(track => track.stop());
      }
      if (recordedChunks.length > 0) {
        const blob = new Blob(recordedChunks, { type: 'audio/webm' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'call-recording.webm';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    };
  }, [call, callAgent, localVideoStream, mediaRecorder, recordedChunks]); // Added all necessary dependencies for cleanup

  return (
    <Box
      sx={{
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(3),
        boxSizing: 'border-box',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: theme.spacing(4),
          borderRadius: theme.shape.borderRadius * 2,
          width: '100%',
          maxWidth: call ? '1400px' : '600px', // Expand width when in call
          textAlign: 'center',
          transition: 'max-width 0.3s ease-in-out',
          backgroundColor: theme.palette.background.paper,
          boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom
          sx={{ color: theme.palette.primary.main, fontWeight: 700 }}
        >
          Azure Communication Room
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2, borderRadius: theme.shape.borderRadius }}>
            {error}
          </Alert>
        )}

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <CircularProgress sx={{ color: theme.palette.primary.main }} />
          </Box>
        )}

        {!call ? ( // Before joining a call
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
            {/* Add Display Name input */}
            <TextField
              label="Display Name"
              variant="outlined"
              fullWidth
              value={displayName}
              onChange={e => setDisplayName(e.target.value)}
              placeholder="Your name (optional)"
              sx={{ borderRadius: theme.shape.borderRadius }}
            />
            <TextField
              label="Room ID"
              variant="outlined"
              fullWidth
              value={roomId}
              onChange={e => setRoomId(e.target.value)}
              placeholder="e.g., '12345678-abcd-efgh-ijkl-1234567890ab'"
              sx={{ borderRadius: theme.shape.borderRadius }}
            />
            <TextField
              label="ACS User Token"
              variant="outlined"
              fullWidth
              value={userToken}
              onChange={e => setUserToken(e.target.value)}
              placeholder="Your Azure Communication Services User Token"
              sx={{ borderRadius: theme.shape.borderRadius }}
            />
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel id="camera-select-label">Select Camera</InputLabel>
              <Select
                labelId="camera-select-label"
                id="camera-select"
                value={selectedCameraId}
                label="Select Camera"
                onChange={handleCameraChange}
              >
                {videoDevices.length === 0 && <MenuItem value=""><em>No cameras found</em></MenuItem>}
                {videoDevices.map((device) => (
                  <MenuItem key={device.id} value={device.id}>
                    {device.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mt: 1 }}>
              <InputLabel id="microphone-select-label">Select Microphone</InputLabel>
              <Select
                labelId="microphone-select-label"
                id="microphone-select"
                value={selectedMicrophoneId}
                label="Select Microphone"
                onChange={handleMicrophoneChange}
              >
                {audioDevices.length === 0 && <MenuItem value=""><em>No microphones found</em></MenuItem>}
                {audioDevices.map((device) => (
                  <MenuItem key={device.id} value={device.id}>
                    {device.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={joinRoom}
              disabled={loading || !callClient}
              sx={{
                mt: 2,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.9),
                },
                borderRadius: theme.shape.borderRadius,
                height: 50,
              }}
            >
              Join Room
            </Button>
          </Box>
        ) : ( // After joining a call
          <Box sx={{ mt: 3 }}>
            {displayName && (
              <Typography
                variant="h5"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                  mb: 2,
                }}
              >
                Welcome, {displayName}!
              </Typography>
            )}
            <Typography variant="h5" component="h1" gutterBottom
              sx={{ color: theme.palette.text.primary }}
            >
              In Call: Room ID - {roomId}
            </Typography>
            {/* Display Call Duration */}
            <Typography variant="h6" sx={{ mb: 2, color: theme.palette.text.secondary }}>
              Call Duration: {formatDuration(callDuration)}
            </Typography>

            <Grid container spacing={2}>
              {/* Local Video Stream */}
              <Grid item xs={12} md={4}>
                <Paper
                  sx={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: '75%', // 4:3 aspect ratio (or 56.25% for 16:9)
                    backgroundColor: '#333',
                    borderRadius: theme.shape.borderRadius,
                    overflow: 'hidden',
                    mb: 2,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                  }}
                >
                  <Box
                    ref={localVideoRef}
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      '& video': {
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: theme.shape.borderRadius,
                      },
                    }}
                  >
                    {!isCameraOn && (
                      <Typography sx={{ color: 'white', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        Local Video Off
                      </Typography>
                    )}
                  </Box>
                  <Typography
                    variant="caption"
                    sx={{
                      position: 'absolute',
                      bottom: theme.spacing(1),
                      left: theme.spacing(1),
                      color: 'white',
                      backgroundColor: alpha(theme.palette.text.primary, 0.5),
                      borderRadius: theme.shape.borderRadius / 2,
                      px: 1,
                    }}
                  >
                    {displayName ? displayName : 'You'}
                  </Typography>
                </Paper>
              </Grid>

              {/* Remote Participants */}
              {remoteParticipants.length > 0 ? (
                remoteParticipants.map(participant => (
                  <Grid item xs={12} md={4} key={participant.identifier.rawId}>
                    <Paper
                      sx={{
                        position: 'relative',
                        width: '100%',
                        paddingTop: '75%', // 4:3 aspect ratio
                        backgroundColor: '#333',
                        borderRadius: theme.shape.borderRadius,
                        overflow: 'hidden',
                        mb: 2,
                        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
                      }}
                    >
                      <Box
                        ref={el => remoteVideoRefs.current.set(participant.identifier.rawId, el)}
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          '& video': {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: theme.shape.borderRadius,
                          },
                        }}
                      >
                        {participant.videoStreams.length === 0 && (
                          <Typography sx={{ color: 'white', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                            {participant.displayName || 'Remote'} Video Off
                          </Typography>
                        )}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          position: 'absolute',
                          bottom: theme.spacing(1),
                          left: theme.spacing(1),
                          color: 'white',
                          backgroundColor: alpha(theme.palette.text.primary, 0.5),
                          borderRadius: theme.shape.borderRadius / 2,
                          px: 1,
                        }}
                      >
                        {participant.displayName || `Participant ${participant.identifier.rawId.substring(0, 8)}`}
                      </Typography>
                    </Paper>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mt: 2 }}>
                    Waiting for other participants to join...
                  </Typography>
                </Grid>
              )}
            </Grid>

            {/* Call Controls */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                mt: 3,
                p: 2,
                backgroundColor: theme.palette.action.hover,
                borderRadius: theme.shape.borderRadius,
              }}
            >
              <Tooltip title={isMuted ? 'Unmute' : 'Mute'}>
                <IconButton
                  onClick={toggleMute}
                  disabled={loading}
                  sx={{
                    backgroundColor: isMuted ? theme.palette.error.main : theme.palette.primary.main,
                    color: theme.palette.common.white,
                    '&:hover': {
                      backgroundColor: isMuted ? alpha(theme.palette.error.main, 0.9) : alpha(theme.palette.primary.main, 0.9),
                    },
                  }}
                >
                  {isMuted ? <MicOffIcon /> : <MicIcon />}
                </IconButton>
              </Tooltip>

              <Tooltip title={isCameraOn ? 'Turn Camera Off' : 'Turn Camera On'}>
                <IconButton
                  onClick={() => toggleCamera()}
                  disabled={loading || videoDevices.length === 0}
                  sx={{
                    backgroundColor: isCameraOn ? theme.palette.primary.main : theme.palette.error.main,
                    color: theme.palette.common.white,
                    '&:hover': {
                      backgroundColor: isCameraOn ? alpha(theme.palette.primary.main, 0.9) : alpha(theme.palette.error.main, 0.9),
                    },
                  }}
                >
                  {isCameraOn ? <VideocamIcon /> : <VideocamOffIcon />}
                </IconButton>
              </Tooltip>

              <Tooltip title="End Call">
                <IconButton
                  onClick={hangUp}
                  disabled={loading}
                  sx={{
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.common.white,
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.secondary.main, 0.9),
                    },
                  }}
                >
                  <CallEndIcon />
                </IconButton>
              </Tooltip>

              {/* Optional: Settings button for device selection */}
              <Tooltip title="Device Settings">
                <IconButton
                  // onClick={() => alert('Open device settings modal')} // Replaced alert with comment
                  sx={{
                    backgroundColor: theme.palette.info.main,
                    color: theme.palette.common.white,
                    '&:hover': {
                      backgroundColor: alpha(theme.palette.info.main, 0.9),
                    },
                  }}
                >
                  <SettingsIcon />
                </IconButton>
              </Tooltip>

              {/* Record Button */}
              <Tooltip title={isRecording ? 'Stop Recording' : 'Start Recording'}>
                <IconButton
                  onClick={isRecording ? stopRecording : startRecording}
                  sx={{
                    backgroundColor: isRecording ? theme.palette.error.main : theme.palette.info.main,
                    color: theme.palette.common.white,
                    '&:hover': {
                      backgroundColor: isRecording ? alpha(theme.palette.error.main, 0.9) : alpha(theme.palette.info.main, 0.9),
                    },
                  }}
                >
                  {isRecording ? <StopIcon /> : <FiberManualRecordIcon />}
                </IconButton>
              </Tooltip>
            </Box>

            {recordedChunks.length > 0 && (
              <Button
                variant="outlined"
                onClick={() => {
                  const blob = new Blob(recordedChunks, { type: 'audio/webm' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.style.display = 'none';
                  a.href = url;
                  a.download = 'call-recording.webm';
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                }}
              >
                Download Recording
              </Button>
            )}
          </Box>
        )}

        <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.secondary }}>
          Status: {status}
        </Typography>
      </Paper>
    </Box>
  );
}